export default __webpack_public_path__ + "static/media/instagram-stories.973ed3cd.jpg";